export default function AllergenChips({ allergens = [], testid, empty = "—" }) {
  if (!allergens.length) return <span className="text-[#8C7A6B] text-xs" data-testid={testid}>{empty}</span>;
  return (
    <div className="flex gap-1 flex-wrap" data-testid={testid}>
      {allergens.map((a) => (
        <span
          key={a}
          data-testid={`allergen-chip-${a}`}
          className="inline-flex items-center px-2 py-0.5 rounded-full text-[10px] font-semibold border bg-[#FEF2F2] text-[#B91C1C] border-[#FECACA]"
        >
          {a.replace(/_/g, " ")}
        </span>
      ))}
    </div>
  );
}
